import React from 'react';

class Menu extends React.Component {
	render() {
		return (
			<ul className="menu-list">
				{
					this.props.children
				}
			</ul>
		)
	}
}

export default Menu;


// WEBPACK FOOTER //
// ./src/components/menu/Menu.jsx